import React, { Component } from 'react';
import { StepPage } from '../../controls/StepPage';
import { FormattedMessage } from 'react-intl';
import authorizeService from '../../api-authorization/AuthorizeService';
import { BaseTextBox } from '../../controls/BaseTextBox';
import toLocalString from '../../infrastructure/DateTimeFunctions';

export class EarmoldStep6Page extends StepPage {

    constructor(props) {
        super(props);
        //DO not need to show user name
        //let model = props.model;
        //if (!model.fillingPerson) {
        //    var user = authorizeService.getCurrentUser();
        //    if (user) {
        //        model.fillingPerson = user.fullName;
        //    }
        //}     
        this.state = {
            propertyChanged: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    notifyPropertyChanged() {
        let propertyChanged = !this.state.propertyChanged;
        this.setState({ propertyChanged: propertyChanged });
    }


    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        var model = this.props.model;
        if (model) {
            switch (name) {
                case "fillingPerson":
                    model.fillingPerson = value;
                    break;
                case "contactDetails":
                    model.contactDetails = value;
                    break;               
            }

            this.notifyPropertyChanged();
        }
    }

    componentDidMount() {
       
    }

    validate() {
        var fillingPerson = this.props.model.fillingPerson;
        if (!fillingPerson || (fillingPerson && fillingPerson.trim() == '')) {
            return { state: false, msg: "FillingPersonRequired" };
        }
        var contactDetails = this.props.model.contactDetails;
        if (!contactDetails || (contactDetails&&contactDetails.trim() == '')) {
            return { state: false, msg: "ContactDetailsRequired" };
        }
        return { state: true, msg: "todo check page6" };
    }
      
    render() {
        let model = this.props.model;
        if (!model) {
            return null;
        }
        
        var orderTime = model.orderTime ? toLocalString(model.orderTime, true) : "";
        return <div className="flex gap-6">            
            <div className="py-1">
                <div className="">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="FillingPerson" /><span className="font-bold text-red-600">*</span></label>
                    <BaseTextBox type="text" name="fillingPerson" classnames="mt-1" value={model.fillingPerson} onChange={this.handleInputChange} />
                </div>
                <div className="mt-2">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="ContactDetails" /><span className="font-bold text-red-600">*</span></label>
                    <BaseTextBox type="text" name="contactDetails" classnames="mt-1" value={model.contactDetails} onChange={this.handleInputChange} />
                </div>
                <div className="mt-2">
                    <label className="block text-sm font-medium text-gray-700"><FormattedMessage id="Date" /></label>
                    <BaseTextBox type="text" classnames="mt-1" value={orderTime} readOnly="readonly"/>
                </div>
            </div>
        </div>
    }
}
